var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAction2Img = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 208,
  height: 239,
  viewBox: "0 0 208 239",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M146.463 168.37L143.509 194.406L145.415 194.501L144.913 201.004L140.198 201.147C139.78 203.617 139.627 206.124 139.744 208.626L154.869 208.142L146.463 168.37Z",
  fill: "#FECFC4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M120.214 191.827C120.143 191.803 122.358 192.351 122.358 192.351L126.026 157.192L114.902 141.685L112.973 160.575C113.066 167.721 104.011 174.69 96.2986 170.722L61.3793 154.81L60.7148 157.338L54.5717 154.5L56.4522 148.474C54.5955 147.442 52.5976 146.688 50.5222 146.235L64.0709 210.858L122.953 209.168L124.049 199.545L119.571 198.473C119.571 198.473 120.286 191.851 120.214 191.827Z",
  fill: "#FECFC4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M94.7026 110.767L91.2298 94.1158L38.2974 87.4712L47.0632 129.99L50.803 128.966L62.6655 134.469L65.6431 129.538L71.9542 132.158C71.6458 132.492 70.3582 134.588 70.3582 134.588L88.9857 142.972C84.4837 119.176 94.7026 110.767 94.7026 110.767Z",
  fill: "#FECFC4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M102.563 69.463C101.658 65.9626 94.1785 60.1267 94.1785 60.1267C91.295 57.1968 95.0561 56.6489 95.0561 56.6489C94.8866 56.3643 94.8034 56.0367 94.8167 55.7057C94.83 55.3747 94.9392 55.0548 95.131 54.7847C95.3228 54.5147 95.5889 54.3062 95.897 54.1847C96.2052 54.0631 96.542 54.0338 96.8665 54.1001C97.3429 54.3145 97.5811 53.5986 97.5811 53.5986L31.4609 55.6246L34.8898 71.9892C34.8898 71.9892 75.1925 75.0845 92.2717 76.0374C92.397 76.0374 99.1495 75.3253 99.2748 75.3002C103.373 74.5141 102.563 69.463 102.563 69.463Z",
  fill: "#FECFC4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M122.215 52.9043L107.547 53.3569C107.547 53.3569 114.979 62.5277 111.954 66.5771C111.477 67.1134 110.889 67.5386 110.231 67.8226C109.572 68.1066 108.859 68.2425 108.142 68.2207C108.197 69.381 108.676 70.4808 109.488 71.3107C110.301 72.1407 111.39 72.6428 112.549 72.7215L124.912 65.7434L122.215 52.9043Z",
  fill: "#FECFC4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M128.837 84.0176L123.549 87.0666V109.529L140.412 139.352L128.837 84.0176Z",
  fill: "#FECFC4"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M203.56 86.709L200.629 82.0879L172.671 99.7626L175.53 87.114L170.194 85.8991L165.876 104.979C165.758 105.507 165.798 106.058 165.994 106.562C166.189 107.066 166.53 107.5 166.973 107.81C167.267 108.016 167.599 108.161 167.949 108.239L187.029 112.55L188.244 107.215L175.595 104.356L203.56 86.709Z",
  fill: "#FECFC4"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9117 26.7546C27.813 26.1187 27.5893 25.5086 27.2537 24.9596C26.918 24.4105 26.477 23.9333 25.9561 23.5555C25.4351 23.1778 24.8445 22.9068 24.2183 22.7584C23.5922 22.61 22.9428 22.587 22.3077 22.6907C21.6726 22.7945 21.0643 23.023 20.5179 23.3629C19.9715 23.7029 19.4978 24.1477 19.1242 24.6716C18.7505 25.1956 18.4843 25.7883 18.3408 26.4156C18.1974 27.043 18.1795 27.6925 18.2883 28.3268C18.5058 29.5947 19.2155 30.7252 20.2628 31.4722C21.3102 32.2191 22.6103 32.5219 23.8799 32.3144C25.1495 32.107 26.2856 31.4063 27.0408 30.3649C27.796 29.3235 28.1091 28.0258 27.9117 26.7546Z",
  fill: "#6153BD"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M89.0333 142.973C88.9142 142.471 82.578 140.065 82.578 140.065L90.8437 150.785C90.8437 150.785 89.6765 146.568 89.0333 142.973Z",
  fill: "#6153BD"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M103.683 47.2402C103.563 47.0411 103.403 46.8687 103.214 46.7335C103.024 46.5983 102.809 46.5032 102.582 46.4541C102.355 46.4049 102.12 46.4027 101.891 46.4477C101.663 46.4926 101.447 46.5837 101.255 46.7153C101.063 46.8469 100.9 47.0164 100.776 47.2132C100.652 47.41 100.57 47.6301 100.534 47.8599C100.498 48.0897 100.51 48.3244 100.568 48.5497C100.626 48.7749 100.729 48.9859 100.872 49.1697C100.544 48.9994 100.17 48.9412 99.8063 49.0041C99.4425 49.0669 99.1094 49.2474 98.858 49.5177C98.6065 49.788 98.4507 50.1334 98.4144 50.5008C98.378 50.8681 98.4632 51.2373 98.6567 51.5517C98.3326 51.4846 97.9959 51.514 97.6883 51.6361C97.3806 51.7581 97.1154 51.9676 96.9254 52.2387C96.7355 52.5097 96.629 52.8304 96.6192 53.1613C96.6094 53.4921 96.6966 53.8186 96.8702 54.1005C96.5442 54.0268 96.2037 54.0512 95.8915 54.1706C95.5793 54.2901 95.3095 54.4992 95.1159 54.7717C94.9224 55.0442 94.8138 55.3679 94.8038 55.702C94.7938 56.0361 94.8829 56.3657 95.0599 56.6492C94.6959 56.5703 94.316 56.6135 93.979 56.772C93.642 56.9306 93.3666 57.1957 93.1954 57.5265C93.0242 57.8572 92.9667 58.2352 93.0317 58.6019C93.0968 58.9686 93.2809 59.3037 93.5554 59.5553L98.2242 63.6524C100.297 65.6759 102.202 67.8435 102.56 69.4395C102.274 66.7252 101.055 64.0561 100.582 63.8668C95.7231 62.0326 97.3228 57.5983 99.9393 59.2933C101.202 60.1032 101.607 59.9126 101.583 59.1265C101.074 55.3466 103.537 48.677 108.412 54.5468C107.703 53.6015 105.788 50.812 103.683 47.2402Z",
  fill: "#6153BD"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M116.189 129.8L114.926 142.02L120.881 149.927L116.189 129.8Z",
  fill: "#6153BD"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M108.113 68.1994C107.214 68.347 106.292 68.2818 105.422 68.0088L109.519 71.2947C108.789 70.4029 108.304 69.3359 108.113 68.1994Z",
  fill: "#6153BD"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M140.39 216.551C139.587 211.45 139.523 206.26 140.199 201.14C134.795 201.11 129.405 200.583 124.097 199.568L123.168 207.69C127.86 214.383 133.101 223.769 142.39 233.344C142.08 227.71 141.412 222.101 140.39 216.551Z",
  fill: "#6153BD"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M90.534 90.7583L82.316 92.9974L91.2487 94.0693L90.534 90.7583Z",
  fill: "#6153BD"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M55.2812 130.991C47.4443 133.324 36.8919 135.327 24.8627 141.137C30.3001 142.627 35.8278 143.765 41.4115 144.544C46.5104 145.382 51.461 146.954 56.1086 149.212C57.8491 144.101 60.0495 139.159 62.683 134.445L55.2812 130.991Z",
  fill: "#6153BD"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M102.539 93.736L117.308 92.5688L118.356 105.908L112.806 112.459L103.588 107.195L102.539 93.736Z",
  fill: "#6153BD"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M139.745 208.62L154.895 208.142L146.487 168.245",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6839 146.949L64.1424 210.882L123.025 209.119",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1544 87.4951L47.1109 129.967",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M96.7988 53.6714L31.4609 55.6247L34.8911 71.9892",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M124.922 65.8235L122.215 52.9092L107.542 53.3379",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M140.413 139.351L128.766 84.0884",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M147.248 36.9946L122.096 52.9329",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M154.895 208.142L208.442 174.247L191.58 94.3148M165.233 25.6108L175.69 18.9888L190.372 88.5867",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M122.406 192.374L126.074 157.192L115.14 142.256",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M89.0095 142.971L70.382 134.564",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M121.095 150.379L116.206 129.8L112.946 161.122C112.655 163.934 111.368 166.548 109.319 168.495C107.269 170.441 104.591 171.591 101.768 171.736C99.898 171.833 98.0314 171.485 96.3211 170.722L61.3792 154.881",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M102.539 93.736L117.308 92.5688L118.356 105.908L112.806 112.459L103.588 107.195L102.539 93.736Z",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M105.374 68.0586L109.543 71.2982",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M92.2968 76.0371C92.2968 76.0371 100.61 106.837 92.9637 102.287",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M117.438 69.9883V85.2558L100.848 86.6851L98.2756 75.3942",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M123.549 66.6533V109.53L144.319 146.236C146.84 150.687 147.891 155.82 147.32 160.904L143.509 194.395",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M120.267 191.851L119.624 198.568C127.888 200.631 136.414 201.45 144.92 200.998L145.563 194.28C137.055 194.853 128.51 194.032 120.267 191.851Z",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M65.6681 129.514C60.7427 137.28 56.9936 145.732 54.5428 154.595L60.716 157.337C63.0067 148.417 66.7657 139.94 71.8388 132.254L65.6681 129.514Z",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5381 115.27C99.0773 117.066 98.1858 118.722 96.9406 120.096C95.6954 121.47 94.1342 122.519 92.392 123.154",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M122.668 113.458C122.668 113.458 124.764 117.984 128.811 118.96",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9882 31.709C39.1772 32.8298 39.1429 33.977 38.8873 35.0845C38.6316 36.1921 38.1597 37.2383 37.4986 38.1629C36.8374 39.0876 36.0001 39.8725 35.0348 40.4726C34.0694 41.0727 32.995 41.4761 31.8732 41.6598C30.7515 41.8434 29.6045 41.8036 28.4982 41.5427C27.3918 41.2817 26.348 40.8048 25.4265 40.1392C24.505 39.4737 23.7242 38.6326 23.1287 37.6644C22.5332 36.6962 22.1349 35.6198 21.9567 34.4972C21.5989 32.244 22.1479 29.9408 23.4838 28.0913C24.8196 26.2418 26.8335 24.9966 29.085 24.628C31.3364 24.2595 33.6423 24.7975 35.4981 26.1244C37.354 27.4514 38.6088 29.4593 38.9882 31.709Z",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M102.539 69.4644C102.182 67.8684 100.277 65.7033 98.2042 63.6761L93.5354 59.579C93.2608 59.3273 93.0768 58.9923 93.0117 58.6255C92.9467 58.2588 93.0042 57.8809 93.1754 57.5502C93.3466 57.2194 93.622 56.9543 93.959 56.7957C94.296 56.6371 94.6759 56.594 95.0398 56.6729C94.8622 56.3894 94.7726 56.0597 94.7823 55.7253C94.792 55.3909 94.9005 55.0669 95.0942 54.7942C95.288 54.5215 95.5581 54.3123 95.8706 54.193C96.1832 54.0738 96.524 54.0498 96.8502 54.1241C96.676 53.8424 96.5882 53.5157 96.5978 53.1846C96.6073 52.8535 96.7137 52.5325 96.9038 52.2612C97.094 51.99 97.3595 51.7804 97.6675 51.6585C97.9755 51.5366 98.3124 51.5077 98.6367 51.5754C98.4431 51.261 98.358 50.8918 98.3943 50.5244C98.4307 50.157 98.5865 49.8117 98.8379 49.5414C99.0893 49.271 99.4225 49.0906 99.7863 49.0277C100.15 48.9649 100.524 49.023 100.852 49.1933C100.711 49.0094 100.61 48.7988 100.553 48.5744C100.496 48.3499 100.486 48.1163 100.522 47.8877C100.559 47.6591 100.641 47.4402 100.765 47.2445C100.888 47.0488 101.051 46.8802 101.241 46.7491C101.432 46.6179 101.648 46.527 101.875 46.4817C102.102 46.4364 102.335 46.4378 102.562 46.4857C102.788 46.5336 103.003 46.6271 103.192 46.7604C103.381 46.8938 103.541 47.0642 103.663 47.2614C104.692 48.9589 107.057 52.7112 108.126 54.2194",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M162.47 14.8668C162.934 13.494 163.285 12.0848 163.519 10.6543C164.613 5.58063 165.869 6.48705 166.116 11.2022C166.254 13.8475 165.844 18.5865 165.663 21.2318C165.553 22.8529 165.069 27.5442 164.448 32.1892C163.474 39.4782 162.119 51.8171 161.304 59.2014C161.093 61.1061 160.441 62.9353 159.398 64.5437C158.356 66.152 156.954 67.4951 155.301 68.4662L123.441 87.184",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M162.494 17.0117C162.589 16.3923 162.263 11.6057 161.97 7.36443C161.641 2.60037 160.205 1.95722 159.231 7.43589C158.37 12.2714 157.754 13.3195 157.754 13.3195",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M152.918 13.7485C152.918 13.7485 153.104 5.59945 153.109 4.81714C153.145 -0.138734 154.667 -0.187628 155.896 4.19781C157.024 8.22094 158.135 15.9638 158.135 15.9638",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M153.752 15.8684C153.752 15.8684 152.229 12.2001 150.822 8.36499C149.346 4.33936 147.265 4.44216 148.297 9.34162C148.412 9.89074 149.404 15.323 149.702 16.9165C149.885 17.8944 149.988 20.3704 149.154 20.6776C146.725 21.5815 140.629 19.2734 139.745 21.2969C139.175 22.607 143.411 23.8306 146.225 24.9414C147.867 25.5896 148.714 28.2462 148.416 30.0816C148.39 30.2483 144.176 55.0929 144.176 55.0929L112.568 72.6948C111.457 72.5907 110.418 72.1038 109.627 71.3175C108.836 70.5312 108.343 69.4944 108.232 68.3846",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M151.484 16.1784C155.24 15.3259 159.173 15.7271 162.679 17.3218",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M152.988 19.0366C157.181 20.3467 159.73 22.824 159.563 26.7544",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0492 78.991C13.0027 79.154 9.94744 79.0035 6.93229 78.5384C1.38216 77.6608 1.75827 79.3207 6.52734 80.7537C7.81239 81.1398 8.93319 81.4457 9.88601 81.6827C12.673 82.3772 15.4361 83.0617 18.1755 83.8265C28.6301 86.7163 39.2376 87.6352 91.2361 94.1156",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M14.956 72.1795L8.61977 68.5826C4.56656 66.2795 4.88375 64.5582 9.90607 66.5767C10.4527 66.7961 16.0003 69.0176 17.6477 69.6495C18.598 70.0131 21.2245 70.7465 21.6495 70.0783C22.8731 68.1538 21.1267 62.1962 23.3169 61.9079C24.7461 61.7186 25.5522 65.768 26.4135 68.5299C26.915 70.1259 29.5816 71.5789 31.5349 71.7219C31.7016 71.7457 92.2992 76.0321 92.2992 76.0321L99.6597 75.2222C105.138 73.7691 101.519 64.2636 100.589 63.9088C95.7582 62.0633 97.3228 57.6478 99.9456 59.3353C101.465 60.3132 101.632 59.8368 101.553 58.8138C101.221 54.5148 104.436 47.39 110.069 57.0247C117.945 70.4882 105.377 68.0573 105.377 68.0573",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1921 72.4619C16.1921 72.4619 5.88038 69.9545 5.18708 69.7714C-0.159949 68.3447 -0.168723 70.1914 4.28191 71.8914C7.40327 73.0912 10.5159 74.3135 13.6195 75.5585",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4299 75.7994C11.9588 75.4449 8.50823 74.9122 5.09185 74.2034C-0.361741 73.1026 -0.122282 74.7463 4.37725 76.371C7.14194 77.4337 9.97502 78.3091 12.8573 78.9913",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7111 71.0601C15.4127 74.3257 15.4127 77.9644 16.7111 81.2301",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M19.527 73.0889C20.456 77.1383 22.7427 79.9729 26.8636 80.7828",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M124.097 199.568L122.62 212.549C127.259 219.076 132.196 229.176 142.413 239.204C142.539 231.596 141.867 223.995 140.407 216.527C139.558 211.43 139.498 206.232 140.231 201.117",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6501 167.22L33.0093 166.244",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M40.7271 164.481L45.0862 163.504",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M35.0101 157.144L36.0106 161.503",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7495 169.221L38.7274 173.58",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M29.7458 160.86L33.5333 163.242",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2268 167.482L43.9904 169.864",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3702 158.24L38.9882 162.027",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7481 168.697L32.3661 172.485",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M167.949 108.266C167.421 108.15 166.94 107.879 166.566 107.488C166.193 107.097 165.944 106.605 165.851 106.072C165.789 105.719 165.798 105.356 165.876 105.006L170.164 85.9263L175.5 87.1411L172.671 99.7621L200.636 82.085L203.566 86.7061L175.578 104.383L188.226 107.242L187.005 112.58L167.949 108.266Z",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M195.223 61.6752L199.725 55.2913L193.389 50.9084L197.867 44.5246L191.483 39.8796L195.985 33.5196L189.435 28.8984",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M200.368 49.1693L204.869 42.7855L198.534 38.4025L203.011 32.0187L196.628 27.3737L201.13 21.0137L194.58 16.3926",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M62.7132 134.445L50.8507 128.942C43.2031 131.277 32.0565 132.776 19.3126 139.304C26.4803 141.843 33.8988 143.608 41.4417 144.57C46.5317 145.388 51.475 146.952 56.11 149.208",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M82.316 92.9974L90.534 90.7583L94.7264 110.767C94.7264 110.767 82.3399 120.2 90.8399 150.784L82.5743 140.065",
  stroke: "#120071",
  strokeWidth: 0.12,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAction2Img);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action2-img.f63b5dcd0991c942758ec9d1b5b48de9.svg";